export default {
    offerDataBegin(state) {
        state.loadingOffer = true;
        state.errorOffer = false;
    },
    offerDataSuccess(state, data) {
        const approvals = data.product.customerApprovals || [];
        data.product.customerApprovals = approvals;
        data.product.customerApprovalsValidation = new Array(approvals.length).fill(false);
        state.offer = data;
        state.loadingOffer = false;
    },
    offerDataErr(state, err) {
        state.loadingOffer = false;
        state.loadingOfferError = true;
        state.errorOffer = err;
    },
    signOfferDataCreateBegin(state) {
        state.loadingSignOffer = true;
        state.errorSignOffer = false;
    },
    signOfferDataCreateSuccess(state) {
        state.loadingSignOffer = false;
    },
    signOfferDataCreateErr(state, err) {
        state.loadingSignOffer = false;
        state.errorSignOffer = err;
    },
    cleanOffer(state) {
        state.offer = null;
    },


    payOfferDataCreateBegin(state) {
        state.loadingPayOffer = true;
        state.errorPayOffer = false;
    },
    payOfferDataCreateSuccess(state) {
        state.loadingPayOffer = false;
    },
    payOfferDataCreateErr(state, err) {
        state.loadingPayOffer = false;
        state.errorPayOffer = err;
    },

};
